import React, { useEffect, useState } from "react";
import "./css.css";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { db } from "../config_firebase";
import {
    collection,
    addDoc,
    getDocs,
    doc,
  } from "firebase/firestore";

/**
 * @author
 * @function Login
 *
 **/

 export const Instructions = (props) => {
    // const [pic, setPic] = useState(img1);
    const history = useNavigate();
    const [url, setUrl] = useState(window.location.href);
    const [userId, setUserId] = useState("");

    useEffect(() => {
        const iosa = url.split(",");
        setUserId(iosa[1]);
      }, []);

    async function addclick(data) {
    const docRef = await addDoc(collection(db, "clicksdata"), {
        data,
    });
    }

    const next = () => {
        const instructions_button = {
            time: Date.now(),
            userId: localStorage.getItem("user_id"),
            buttonType: "instructions_button",
        };
        addclick(instructions_button);
        console.log("g", userId);
        history(`/instructions2/?,${userId}`);
    };
    
    return(
        <div className="main">
            <div className="content">
                <h1>Study Instructions</h1>
                <p>
                    <br></br>1. In this study, you will make price predictions for 5 stocks in the stock market.
                    <br></br>Each stock is of a real company, but we will not disclose the name of the company.
                    <br></br>We will give you information about each company, including graphs of changes in the stock price, 
                    <br></br>from the company’s real historical data, at a certain point in the past.
                    <br></br>Your task is to predict the stock price exactly one month from the time point of the
                    information you received.
                    <br></br>2. <span className="award">Each accurate prediction (in the range of ±3% of the correct answer) will award you a chance to win a $10 bonus. 
                    <br></br>For each stock, we will draw one winner among those who provided an accurate estimate.
                    </span>
                    <br></br><br></br> <u>Technical notes: </u>  
                    <br></br>3. Browsing back and forth is not possible. Therefore, please progress to the next 
                     page only when your answers are final.
                    <br></br>4. The use of other browsers or web pages during the task is not allowed.
                    <br></br>5. At the end of the task, press the "Click for participation confirmation" button in order to properly get paid.
                    <br></br>6. Click to proceed to the guidelines on how to do the task.
                </p>
            </div>
            <div>
                <Button variant="outline-light" className="instructionsnextbutton" onClick={next}>Next</Button>
            </div>
        </div>
    );
}